// ✅ 견적서 화면 공통 표시 포맷 — QuotationList/QuotationForm이 같은 함수를 쓴다.
// ⚠️ 표시 전용이다. 저장값·계산값에는 절대 쓰지 않는다 — 백엔드로 보내는 payload는
//    입력값 그대로 넘겨야 하고(계약개월수는 0.5 단위 소수), 금액 계산은 전부
//    서버(calc.py)의 Decimal 산술이다. 여기서 반올림한 값이 계산에 흘러들면
//    7.5개월 계약이 8개월로 계산되는 식의 오차가 생긴다.

/**
 * 계약개월수 표시 — 정수면 소수점 없이, 아니면 소수 1자리.
 *   12 / "12.00"  → "12"
 *   7.5 / "7.50"  → "7.5"
 * ⚠️ API의 months는 DecimalField라 문자열 "12.00"으로 내려온다. 그대로 찍으면
 *    목록에 "12.00개월"이 나온다(2026-08-21 실측). Number()로 한 번 통과시킨다.
 * 숫자로 해석되지 않으면 원본을 그대로 돌려준다(빈 값·null이 "NaN"이 되지 않게).
 */
export function fmtMonths(months) {
  const n = Number(months);
  if (months === null || months === undefined || months === "" || Number.isNaN(n)) {
    return months ?? "";
  }
  return Number.isInteger(n) ? String(n) : n.toFixed(1);
}
